export const paymentModelButtons = [
  { text: "Keep 100%", name: "Keep 100%", value: "Keep 100" },
  { text: "Shared", name: "Shared", value: "Shared" },
  { text: "Flat Fee", name: "Flat Fee", value: "Flat Fee" },
];

export const euCountryCodes = [
  "AT",
  "BE",
  "DK",
  "EE",
  "FI",
  "FR",
  "DE",
  "GR",
  "IE",
  "IT",
  "LV",
  "LT",
  "LU",
  "NL",
  "NO",
  "PL",
  "PT",
  "SK",
  "SI",
  "ES",
  "SE",
  "CH",
  "GB",
];

export const S3_URL = process.env.S3_URL;
export const CDN_URL = process.env.CDN_URL;
export const FILEPICKER_API_KEY = process.env.FILEPICKER_API_KEY;
export const FILESTACK_SIGNATURE = process.env.FILESTACK_SIGNATURE;
export const FILESTACK_POLICY = process.env.FILESTACK_POLICY;
export const FILESTACK_BUCKET = process.env.FILESTACK_BUCKET;
export const STRIPE_KEY = process.env.STRIPE_KEY;
export const CAPTCHA_KEY = process.env.RECAPTCHA_KEY;
export const TURNSTILE_KEY = process.env.TURNSTILE_KEY;

export const FILESTACK_IMAGE_PATH = "images/";
export const fit = "crop";
export const logoFit = "clip";
